"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSurveyStatusesResponseToJSON = exports.MultipleSurveyStatusesResponseFromJSONTyped = exports.MultipleSurveyStatusesResponseFromJSON = exports.instanceOfMultipleSurveyStatusesResponse = void 0;
var runtime_1 = require("../runtime");
var SurveyStatusesResponse_1 = require("./SurveyStatusesResponse");
/**
 * Check if a given object implements the MultipleSurveyStatusesResponse interface.
 */
function instanceOfMultipleSurveyStatusesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMultipleSurveyStatusesResponse = instanceOfMultipleSurveyStatusesResponse;
function MultipleSurveyStatusesResponseFromJSON(json) {
    return MultipleSurveyStatusesResponseFromJSONTyped(json, false);
}
exports.MultipleSurveyStatusesResponseFromJSON = MultipleSurveyStatusesResponseFromJSON;
function MultipleSurveyStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyStatuses': !(0, runtime_1.exists)(json, 'survey_statuses') ? undefined : (json['survey_statuses'].map(SurveyStatusesResponse_1.SurveyStatusesResponseFromJSON)),
    };
}
exports.MultipleSurveyStatusesResponseFromJSONTyped = MultipleSurveyStatusesResponseFromJSONTyped;
function MultipleSurveyStatusesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_statuses': value.surveyStatuses === undefined ? undefined : (value.surveyStatuses.map(SurveyStatusesResponse_1.SurveyStatusesResponseToJSON)),
    };
}
exports.MultipleSurveyStatusesResponseToJSON = MultipleSurveyStatusesResponseToJSON;
